export default "__VITE_ASSET__bb4dd70b__"